<?xml version="1.0" encoding="UTF-8"?>
<svg width="256px" height="256px" viewBox="0 0 256 256" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>icon-centered-complete</title>
    <g id="icon-centered-complete" stroke="none" stroke-width="1"  fill-rule="evenodd">
        <path d="M204,186 L204,224 L52,224 L52,186 L204,186 Z M257,110 L257,148 L0,148 L0,110 L257,110 Z M204,32 L204,70 L52,70 L52,32 L204,32 Z" id="Combined-Shape" fill-rule="nonzero"></path>
    </g>
</svg>